import * as React from 'react';
import { Button } from 'reactstrap';

import './ConfigurationArchive.page.scss';
import { RequestApiResult, requestAPIActions } from 'loopback-react-request';
import { ConfigurationModel, UserDataModel } from 'franke-trough-dependencies';
import { connect } from 'react-redux';
import { GlobalPrivateState } from 'src/api';
import { Redirect } from 'react-router';

import { FormattedMessage } from 'react-intl';
import MESSAGES from './ConfigurationArchive.messages';
import { isConfigurationEditable } from 'src/redux/utils.redux';

export interface ConfigurationArchiveProps {
  dispatch: any;
  configuration: RequestApiResult<ConfigurationModel & {archived?: boolean}>;
  userData: RequestApiResult<UserDataModel & {archivedConfigurations?: string[]}>;
  configurationId: string;
}

export interface ConfigurationArchiveState {
  redirect: boolean;
}

export class ConfigurationArchivePartial extends React.Component<ConfigurationArchiveProps, ConfigurationArchiveState> {
  constructor(props: ConfigurationArchiveProps) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
    this.state = {
      redirect: false,
    };
  }

  componentDidUpdate (prevProps: ConfigurationArchiveProps) {
    const configuration = this.configuration;
    const userData = this.userData;
    const prevUserData = prevProps.userData.result;

    if ((userData && userData.updated_at) !== (prevUserData && prevUserData.updated_at)) {
      if (!this.state.redirect && userData && configuration && userData.archivedConfigurations && userData.archivedConfigurations.includes(configuration.id)) {
        // Configuration is archived
        this.setState({
          redirect: true,
        });
      }
    }
  }

  public render() {
    return (
      <div className="page-configuration-archive d-flex justify-content-center align-items-center vh-100">
        <div className="container">
          <div className="row">
            <div className="col-12 text-center">
              <h3 className="mb-5">
                <FormattedMessage {...MESSAGES.configurationArchiveHeadline} />
              </h3>
              <Button
                className="btn"
                onClick={this.handleClick}
              >
                <FormattedMessage {...MESSAGES.configurationArchiveButton} />
              </Button>
            </div>
          </div>
        </div>
        {this.state.redirect && (
          <Redirect to={`/`} />
        )}
      </div>
    );
  }

  private get userData() {
    return this.props.userData && this.props.userData.result;
  }

  private get configuration() {
    return this.props.configuration && this.props.configuration.result;
  }

  private dispatchRemove() {
    if (!this.userData || !this.configuration) {
      return;
    }

    const data = this.userData;
    data.archivedConfigurations = data.archivedConfigurations && [...data.archivedConfigurations, this.configuration.id] || [this.configuration.id];
    this.props.dispatch(requestAPIActions.load(
      'userData', {
        url: `/UserData/${this.userData.id}`,
        options: {
          method: 'PATCH',
          data,
        },
      },
      true,
    ));
  }

  private handleClick(event: React.SyntheticEvent<HTMLButtonElement>) {
    this.dispatchRemove();
  }
}

export const ConfigurationArchive = connect((state: GlobalPrivateState) => ({
  configuration: state.configuration,
  userData: state.userData,
}))(ConfigurationArchivePartial);

export default ConfigurationArchive;
